import type { BackendRouteDefinition } from '../types';
import type { CreatePaymentPage } from '@cloudFunctions/types/clientToFirmPayments/createPaymentPage';
import { withIdempotencyKeyHeader } from '../../../../../shared/backend/routes/idempotency';
import { buildDeterministicIdempotencyKey } from './buildDeterministicIdempotencyKey';

export const createPaymentPageRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/payment-pages',
  body: (requestData: CreatePaymentPage.Props) => requestData,
  headers: (requestData: CreatePaymentPage.Props) =>
    // This route creates a new document ID server-side, so we derive a stable
    // key from the request payload until the frontend grows explicit caller-
    // supplied mutation keys. The route keeps the replay TTL short to limit how
    // long an intentional identical re-submit would coalesce.
    withIdempotencyKeyHeader({
      idempotencyKey: buildDeterministicIdempotencyKey({
        prefix: 'create-payment-page',
        requestData,
      }),
    }),
} as const satisfies BackendRouteDefinition;
